import { create } from "zustand";

/**
 * Transient, in-memory boot state. Deliberately NOT persisted: it describes
 * what has finished running in *this* page load, so a value restored from a
 * previous session would be actively wrong.
 */
export interface BootState {
  /**
   * True once Layout's `initializeData` has finished resolving authentication
   * for this page load — i.e. the one-shot `?sid=` SSO redemption and the
   * cookie-token reconciliation have both run.
   *
   * Consumers that act on `isAuthenticated()` during boot must wait for this.
   * `isAuthenticated()` is only a token-presence check, so before the SSO
   * handoff lands it can still report `true` for a stale token rehydrated from
   * a previous session — which would send a deep link to checkout with a token
   * the backend then rejects.
   */
  isAuthBootstrapped: boolean;
  setAuthBootstrapped: (value: boolean) => void;
}

export const useBootStore = create<BootState>()(set => ({
  isAuthBootstrapped: false,
  setAuthBootstrapped: (value: boolean) => {
    set({ isAuthBootstrapped: value });
  },
}));

export const useBootState = (): BootState => {
  return useBootStore(state => {
    return state;
  });
};
